import { ServerAPI } from '../GeneralFunction';

const DashboardAPI = {
	getdashboardactivecampaignlist: (data) => {
		let url = "get_dashboard_active_campaign_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getdashboardgoallist: (data) => {
		let url = "get_dashboard_goal_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getDashboardProfiles: (data = {}) => {
		let url = "get_dashboard_profiles";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	createDashboardProfile: (data) => {
		let url = "create_dashboard_profile";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	updateDashboardProfile: (data) => {
		let url = "update_dashboard_profile";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	setDefaultDashboardProfile: (data) => {
		let url = "set_default_dashboard_profile";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	deleteDashboardProfile: (data) => {
		let url = "delete_dashboard_profile";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	getBusinessDashboardPhase2Data: (data) => {
		let url = "get_business_dashboard_phase2_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	getMarketingDashboardPhase5Data: (data) => {
		let url = "get_marketing_dashboard_phase5_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	getMarketingDashboardPhase6Data: (data) => {
		let url = "get_marketing_dashboard_phase6_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	createDashboardSnapshotLink: (data) => {
		let url = "create_dashboard_snapshot_link";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	getDashboardSnapshotByToken: (data) => {
		let url = "get_dashboard_snapshot_by_token";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL + url, requestOptions);
	},
	getdashboardsystemusage: (data) => {
		let url = "get_dashboard_system_usage";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
};

export default DashboardAPI;
